import axios from 'axios';
import { env } from '@/config/env';

export const apiClient = axios.create({
  baseURL: env.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login on 401 if NOT on login/auth endpoints
    // This prevents redirect when user enters wrong credentials
    const isAuthEndpoint = error.config?.url?.includes('/auth/login') || 
                          error.config?.url?.includes('/auth/reset-password') ||
                          error.config?.url?.includes('/auth/forgot-password');
    
    const pathname = typeof window !== 'undefined' ? window.location?.pathname : '';
    const isPublicRoute =
      pathname === '/' ||
      pathname.startsWith('/adopt') ||
      pathname.startsWith('/webapp');

    if (error.response?.status === 401 && !isAuthEndpoint && !isPublicRoute) {
      // Only clear session and redirect if user is already logged in
      // and their token expired or is invalid
      sessionStorage.removeItem('auth_token');
      sessionStorage.removeItem('user_data');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
